/**
 * Current page title, surfaced to the consolidated mobile top bar.
 *
 * On mobile the top bar reads `[hamburger] {pageTitle} [search] [bell]`, but
 * the title lives in each page's `OrdoPageHeader`. That header registers its
 * (string) title here on mount and clears it on unmount, so `OrdoTopBar` can
 * render it without every page threading the value up. Desktop keeps the
 * page's own header title; the top bar only consumes this on small screens.
 */

import { create } from 'zustand'

interface PageTitleState {
  title: string | null
  setTitle: (title: string | null) => void
}

export const usePageTitle = create<PageTitleState>((set) => ({
  title: null,
  setTitle: (title) => set({ title }),
}))
